<div class="layout-footer p-fluid p-formgrid grid">
  <div *ngIf="!isExpanded" class="fiel col-12 md:col-1">
    <a [routerLink]="['/accueil']" class="logo">
      <div class="logo-image w-full">
        <img *ngIf="subSiteName" src="assets/layout/images/logo-{{subSiteName}}.svg"  alt="diamond-layout"
        class="footer-logo" />
        <img *ngIf="!subSiteName" src="assets/layout/images/logo-{{ logo }}.svg" alt="diamond-layout" class="footer-logo"/>
      </div>
    </a>
  </div>
  <div *ngIf="isExpanded" class="fiel col-12 md:col-12">
    <div class="fiel col-12 md:col-1">
      <a [routerLink]="['/accueil']" class="logo">
        <div class="logo-image w-full">
          <img *ngIf="subSiteName" src="assets/layout/images/logo-{{subSiteName}}.svg"  alt="diamond-layout"
          class="footer-logo" />
          <img *ngIf="!subSiteName" src="assets/layout/images/logo-{{ logo }}.svg" alt="diamond-layout" class="footer-logo"/>
        </div>
      </a>
    </div>

    <div *ngIf="isExpanded" class="fiel col-12 md:col-12 text-sm text-900 font-regular text-color-secondary">

      <div class="flex align-content-start flex-wrap card-container mb-3">
        <div class="flex align-items-center justify-content-center mr-2"
        *ngIf="footerData.numTel">
          <i class="pi pi-phone text-lg mr-2"></i>
          <div class="text-sm text-900 font-regular text-color-secondary">
            {{ footerData.numTel}}
          </div>
        </div>
      </div>

      <div class="flex align-content-start flex-wrap card-container">
        <div class="flex align-items-center justify-content-center mr-2"
        *ngIf="footerData.email">
        <i class="pi pi-envelope text-lg"></i>
          <div class="flex align-items-center justify-content-center">
              <div class="text-sm text-900 font-regular text-color-secondary ml-2">
              {{ footerData.email}}</div>

          </div>
        </div>
      </div>
      <div class="flex align-content-start flex-wrap card-container">
        <div class="flex align-items-center justify-content-center mr-2 mt-3"
        *ngIf="footerData.adresse">
        <i class="pi pi-map-marker text-lg mr-2"></i>
          <div class="flex align-items-center justify-content-center">
            <div class="text-sm text-900 font-regular text-color-secondary">
              {{ footerData.adresse}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isExpanded &&  footerData.corps"
    class="field col-12 md:col-10 text-sm text-900 font-regular text-color-secondary ml-2"
    [innerHTML]="this.footerData?.corps |safeComment">
  </div>

  <div class="fiel col-12 md:col-12 " *ngIf="isExpanded">
    <hr class="mt-1 mb-1">
  </div>



  <div class=" fiel col-12 md:col-6 text-center">
    <ng-container *ngFor="let doc of documents" class="text-center">
      <label class="text-sm text-900 font-regular text-color-secondary cursor-pointer ml-5"
      style="display: inline-block; margin-bottom: 9px;"
      (click)="downloadDocument(doc)">
        {{doc.libelle}}
      </label>
    </ng-container>

    <ng-container *ngFor="let lien of this.lienUtile" class="text-center">
      <a *ngIf="lien.display" [href]="lien.url" target="_blank" class="text-sm text-900 font-regular text-color-secondary cursor-pointer ml-6">
        {{ lien.libelle }}
      </a>
    </ng-container>
  </div>


  <div class="fiel col-12 md:col-2 mt-2">
    <button pButton pRipple type="button" icon="pi pi-arrow-down" label="Voir plus d'informations"
      class="p-button-outlined mb-2 text-sm show" (click)="expandFooter()" *ngIf="showInfo"></button>
    <button pButton pRipple type="button" icon="pi pi-arrow-up" label="Voir moins d'informations"
      class="p-button-outlined mb-2 text-sm show" (click)="reduireFooter()" *ngIf="hideInfo"></button>
  </div>

    <div class="fiel col-12 md:col-1 text-center reseau">
      <ng-container *ngFor="let reseau of getSortedSocialMediaIcons()">

        <a *ngIf="reseau.display" [href]="reseau.url" target="_blank">
          <i *ngIf="reseau.key === 'LINKEDIN'" class="pi pi-linkedin text-lg text-color-secondary ml-3 cursor-pointer"></i>
          <i *ngIf="reseau.key === 'YOUTUBE'" class="pi pi-youtube text-lg text-color-secondary ml-3 cursor-pointer"></i>
          <i *ngIf="reseau.key === 'TWITTER'" class="fa-brands fa-x-twitter text-lg text-color-secondary ml-3 cursor-pointer"></i>
          <i *ngIf="reseau.key === 'INSTAGRAM'" class="pi pi-instagram text-lg text-color-secondary ml-3 cursor-pointer"></i>
          <i *ngIf="reseau.key === 'FACEBOOK'" class="pi pi-facebook text-lg text-color-secondary ml-3 cursor-pointer"></i>


        </a>
      </ng-container>
    </div>


<i class="pi pi-arrow-circle-up text-lg text-color-secondary cursor-pointer ml-6 icon"
(click)="scrollToTop()"></i>
  <div class="fiel col-12 md:col-1">
     <span class="footer-copyright">Tessi - {{currentYear}}<br>{{appVersion}}
    </span>
  </div>
</div>
